import SharePointJobForm from "./job-form";

export default function NewSharePointJobPage() {
  return <SharePointJobForm mode="create" />;
}
